import { firebaseApp } from "../../firebase/firebase";
import {
  START_TIMER,
  PAUSE_TIMER,
  RESTART_TIMER,
  STOP_TIMER,
  INCREMENT_TIMER,
  SET_TIMER_TASK,
  FETCH_TIMERS,
  NO_TIMERS,
  NOTIFY_ADMIN_FINISHED
} from "../../_actions/types";

let timer = null;

export function startTimer(task) {
  return dispatch => {
    const currentTime = new Date();

    timer = setInterval(() => dispatch(incrementTimer(1)), 1000);

    dispatch({
      type: START_TIMER,
      startTime: String(currentTime),
      task
    });
  };
}

export function restartTimer() {
  return dispatch => {
    timer = setInterval(() => dispatch(incrementTimer(1)), 1000);

    dispatch({
      type: RESTART_TIMER
    });
  };
}

export function incrementTimer(amount) {
  return {
    type: INCREMENT_TIMER,
    amount
  };
}

export function pauseTimer() {
  clearInterval(timer);

  return {
    type: PAUSE_TIMER
  };
}

export const notifyAdminFinished = timer => {
  fetch(
    "https://hooks.slack.com/services/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",
    {
      method: "POST",
      body: JSON.stringify({
        text: `TASK FINISHED
Task Title: ${timer.task},
Property: ${timer.project},
Elasped Time: ${Math.round(timer.totalTime / 60)} Minutes,
VA: ${timer.va},
Client: ${timer.agent},
______________________________
`
      })
    }
  ).then(() => {
    return { type: NOTIFY_ADMIN_FINISHED };
  });
};

export function stopTimer() {
  clearInterval(timer);
  return (dispatch, getState) => {
    const state = getState();
    const timerId = firebaseApp
      .database()
      .ref("timers")
      .push().key;
    const {
      userEmail,
      userId,
      key,
      title,
      startTime,
      elapsedTime
    } = state.timer;
    const timer = {
      userEmail,
      userId,
      key,
      title,
      startTime,
      totalTime: elapsedTime
    };
    firebaseApp
      .database()
      .ref(`/users/${userId}/meta/hours`)
      .once("value")
      .then(snapshot => {
        const updates = {};
        updates[`/users/${userId}/meta/hours`] = snapshot.val() - elapsedTime;
        firebaseApp
          .database()
          .ref()
          .update(updates)
          .then(() => {
            firebaseApp
              .database()
              .ref(`tasks/${key}/timerTotal`)
              .once("value")
              .then(snapshot => {
                const updates = {};
                updates[`tasks/${key}/timerTotal`] =
                  snapshot.val() + elapsedTime;
                firebaseApp
                  .database()
                  .ref()
                  .update(updates);
              });
          });
      });

    let writeLocations = {};
    writeLocations[`timers/${timerId}`] = timer;
    writeLocations[`users/${userId}/timers/${timerId}`] = true;
    writeLocations[`users/${state.auth.user.uid}/timers/${timerId}`] = true;

    firebaseApp
      .database()
      .ref()
      .update(writeLocations);

    dispatch({
      type: STOP_TIMER,
      timer: {
        [timerId]: {
          ...timer
        }
      }
    });
  };
}

export function loadTimersFromFirebase() {
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;

    firebaseApp
      .database()
      .ref(`timers`)
      .on("value", () => {
        firebaseApp
          .database()
          .ref(`users/${id}/timers`)
          .on("value", snapshot => {
            const values = snapshot.val();
            if (values) {
              const timers = [];
              for (let key of Object.keys(values)) {
                firebaseApp
                  .database()
                  .ref(`timers/${key}`)
                  .on("value", snapshot => {
                    timers.push(snapshot.val());
                  });
              }
              dispatch({ type: FETCH_TIMERS, payload: timers });
            } else {
              dispatch({ type: NO_TIMERS });
            }
          });
      });
  };
}

export function setTimerTask(userEmail, userId, key, title) {
  return {
    type: SET_TIMER_TASK,
    userEmail,
    userId,
    key,
    title
  };
}



// WEBPACK FOOTER //
// ./src/components/timetracker/timer_actions.js